import { ReactElement } from 'react';
import { ReactComponent as HospitalIcon } from '../../../icons/Hospital.svg';

import styles from './PatientsInFacility.module.scss';

interface IProps {
  count: number;
}

const PatientsInFacility = ({ count }: IProps): ReactElement => (
  <div className={styles.container}>
    <HospitalIcon className={styles.icon} />
    <span className={styles.text}>Currently in facility: {count} patients</span>
  </div>
);

export default PatientsInFacility;
